import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { trackAuditCta } from "@/tracking/analytics";
import { useBooking } from "./BookingProvider";

const TEXTURE_IMAGE =
    "https://images.unsplash.com/photo-1578662996442-48f60103fc96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzMjV8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZXh0dXJlfGVufDB8fHx8MTc5MTIwNzk2MHww&ixlib=rb-4.1.0&q=80&auto=format&fit=crop&w=1600";

export const AuditCTA = () => {
    const openBooking = useBooking();

    const handleCta = (e) => {
        e.preventDefault();
        trackAuditCta("audit-section");
        openBooking();
    };

    return (
        <section id="audit" className="relative overflow-hidden border-b border-white/5">
            <img
                src={TEXTURE_IMAGE}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover opacity-20 grayscale"
                loading="lazy"
            />
            <div
                aria-hidden="true"
                className="absolute inset-0 bg-ink-900/85"
            />
            <div className="shell relative py-28 md:py-36 lg:py-44">
                <div className="max-w-3xl mx-auto text-center">
                    <Reveal>
                        <p className="eyebrow mb-6">Free Audit</p>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="font-serif font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-white">
                            Find out where your paid acquisition is leaving
                            opportunities on the table.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="mt-8 text-base lg:text-lg leading-relaxed text-zinc-300">
                            Get a free 15-minute Google Ads audit for your law
                            firm, booked as a short call at a time that suits
                            you.
                        </p>
                        <p className="mt-4 text-base lg:text-lg leading-relaxed text-zinc-400">
                            We'll look at your current search presence,
                            campaign structure, conversion tracking,
                            landing-page experience, and opportunities for
                            improvement.
                        </p>
                    </Reveal>
                    <Reveal delay={0.24}>
                        <div className="mt-12 flex items-center justify-center">
                            <a
                                href="#book"
                                data-testid="audit-primary-cta"
                                onClick={handleCta}
                                className="btn-brass group"
                            >
                                Explore My Options
                                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                            </a>
                        </div>
                        <p
                            data-testid="audit-reassurance"
                            className="mt-8 text-sm text-zinc-400"
                        >
                            No obligation. No hard sell. Just actionable
                            feedback.
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

export default AuditCTA;
